import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { DropdownOption } from './dropdown.model';

const POSITIONS_BELOW_FIRST: ConnectedPosition[] = [
  { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
];

const POSITIONS_ABOVE_FIRST: ConnectedPosition[] = [
  { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
  { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
];

@Component({
  selector: 'rk-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: false,
})
export class DropdownComponent implements OnInit {
  @Input() options: DropdownOption[] | undefined;
  @Input() selectedOption?: DropdownOption | undefined;
  @Input() placeholder?: string | undefined;
  @Input() isDisabled?: boolean | undefined;
  @Input() whiteBackground?: boolean | undefined;
  @Input() fullWidth? = false;
  @Input() showAbove? = false;
  @Output() readonly selectionChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('dropdownContainer', { static: true })
  dropdownContainer!: ElementRef;
  isOpen = false;
  overlayPositions: ConnectedPosition[] = POSITIONS_BELOW_FIRST;

  ngOnInit() {
    this.overlayPositions = this.showAbove
      ? POSITIONS_ABOVE_FIRST
      : POSITIONS_BELOW_FIRST;
  }

  /**
   * Whether the dropdown can be opened: when there are several options, or a single
   * option that isn't selected yet.
   */
  get canOpen(): boolean {
    if (!this.options?.length) {
      return false;
    }

    return (
      this.options.length > 1 || this.selectedOption?.value !== this.options[0].value
    );
  }

  toggleDropdown() {
    if (this.canOpen) {
      this.isOpen = !this.isOpen;
    }
  }

  onOptionSelected(option: any) {
    this.selectedOption = option;
    this.selectionChange.emit(option.value);
    this.isOpen = false;
  }

  onOverlayOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this.dropdownContainer.nativeElement.contains(targetElement)) {
      this.isOpen = false;
    }
  }
}
